// IMPORTANT: This file is auto generated from writePlaygroundPages
// Any changes you make to this file here will be overwritten.

export const allComponents = [
  { name: 'Accordion', category: 'Accordions' },
  { name: 'AccordionItem', category: 'Accordions' },
  { name: 'AlertInlineMain', category: 'Alerts' },
  { name: 'SnackBar', category: 'Alerts' },
  { name: 'SuccessToaster', category: 'Alerts' },
  { name: 'WarningPopup', category: 'Alerts' },
  { name: 'AppSideDisplay', category: 'Displays' },
  { name: 'AppTitleBar', category: 'TopBars' },
  { name: 'AudioPlayer', category: 'Media' },
  { name: 'ImageCarousel', category: 'Media' },
  { name: 'VideoPlayer', category: 'Media' },
  { name: 'BasicTile', category: 'Tiles' },
  { name: 'WaveTile', category: 'Tiles' },
  { name: 'BigNumber', category: 'Charts' },
  { name: 'ChartWrapper', category: 'Charts' },
  { name: 'Calendar', category: 'Pickers' },
  { name: 'ColorPicker', category: 'Pickers' },
  { name: 'DatePicker', category: 'Pickers' },
  { name: 'HierarchyPicker', category: 'Pickers' },
  { name: 'LeftRightPicker', category: 'Pickers' },
  { name: 'TreePicker', category: 'Pickers' },
  { name: 'Checkbox', category: 'Buttons' },
  { name: 'DefaultButton', category: 'Buttons' },
  { name: 'FAB', category: 'Buttons' },
  { name: 'FilterButton', category: 'Buttons' },
  { name: 'HeadingButton', category: 'Buttons' },
  { name: 'IconButton', category: 'Buttons' },
  { name: 'SentimentButton', category: 'Buttons' },
  { name: 'TileButton', category: 'Buttons' },
  { name: 'CloudPill', category: 'Pills' },
  { name: 'CustomPill', category: 'Pills' },
  { name: 'Comment', category: 'Cards' },
  { name: 'CondensedExperienceCard', category: 'Cards' },
  { name: 'ExperienceCard', category: 'Cards' },
  { name: 'ExperienceHeader', category: 'Cards' },
  { name: 'Notes', category: 'Cards' },
  { name: 'Drawer', category: 'Drawers' },
  { name: 'SidePanel', category: 'Drawers' },
  { name: 'Dropdown', category: 'Dropdowns' },
  { name: 'EditableText', category: 'TextFields' },
  { name: 'InputField', category: 'TextFields' },
  { name: 'TextArea', category: 'TextFields' },
  { name: 'GenericModal', category: 'Modals' },
  { name: 'Popout', category: 'Modals' },
  { name: 'HorizontalTabBar', category: 'TabBars' },
  { name: 'TabBar', category: 'TabBars' },
  { name: 'VerticalTabBar', category: 'TabBars' },
  { name: 'List', category: 'Lists' },
  { name: 'ListItem', category: 'Lists' },
  { name: 'ProgressBar', category: 'Visuals' },
  { name: 'XIAnimation', category: 'Visuals' },
  { name: 'XIAppIcon', category: 'Visuals' },
  { name: 'XIIcon', category: 'Visuals' },
  { name: 'XISVG', category: 'Visuals' },
  { name: 'Radio', category: 'Radios' },
  { name: 'SearchBox', category: 'Searches' },
  { name: 'Slider', category: 'Sliders' },
  { name: 'Table', category: 'Tables' },
  { name: 'TextToLink', category: 'Micro Components' },
  { name: 'ToggleSwitch', category: 'Switches' },
  { name: 'ToggleText', category: 'Switches' },
  { name: 'ToolTipContent', category: 'ToolTips' },
];
